import "./App.css";
import TheApp from "./routes";
function App() {
	return (
		<>
			<TheApp />
		</>
	);
}

export default App;
